import React, { useEffect, useRef, useState } from "react";
import "./TrackerMarker.css";
import classnames from "classnames";
import moment from "moment";
import { FaGaugeHigh } from 'src/icons';

type VehicleMarkerProps = {
  plateNumber: string;
  status: string;
  lat: number;
  lng: number;
  onClick?: () => void; // Optional click handler
  data: any;
};

const TrackerMarker: React.FC<VehicleMarkerProps> = ({
  plateNumber,
  status,
  onClick,
  data,
}) => {
  const ref = useRef<any>();
  const [isClicked, setIsClicked] = useState(false);
  const [latestData, setLatestData] = useState<any>({});

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsClicked(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setLatestData(data[data?.length - 1]);
  }, [data]);

  return (
    <div ref={ref} onClick={() => setIsClicked(!isClicked)}>
      <div className={classnames("tracker-marker", status)}>
        <div className="tracker-marker__content capitalize">{plateNumber}</div>
        <div className="tracker-marker__pointer" />
      </div>
      {isClicked && (
        <div
          style={{
            position: "absolute",
            bottom: "34px",
            left: "30px",
            transform: "translate(-60% 60%)",
            backgroundColor: "#10253D",
            padding: "5px 0px 10px 10px",
            borderRadius: "5px",
            zIndex: 100,
            boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
          }}
        >
        <div style={{background: 'red', width: '60px', textAlign: 'center', marginTop: '-10px', color: '#FFF', borderRadius: '2px', padding: '2px'}}>
            Stopped
        </div>
          <div className="flex justify-start items-center mt-2">
            <div className="ml-2">
              <p className="text-xs text-white opacity-90 capitalize">{plateNumber}</p>
            </div>
          </div>
          <div className="flex flex-col gap-3 mb-2">
            <div className="flex w-[290px] justify-start items-center mt-4 mb-2 gap-5">
              <div className="flex">
                <div className="w-[30px]">
                  <img
                    src="/assets/icons/orders/events/clock.svg"
                    className="mx-auto opacity-70"
                  />
                </div>
                <div className="flex flex-col ml-2">
                  <p className="text-sm text-white opacity-90">
                    {moment(latestData?.timestamp).format("DD-MM-YYYY") ||
                      "N/A"}
                  </p>
                  <p className="text-sm text-white opacity-90">
                    {moment(latestData?.timestamp).format("HH:mm:ss") || "N/A"}
                  </p>
                </div>
              </div>
              <div className="flex">
                <div className="w-[30px]">
                  <FaGaugeHigh style={{ color: "#FFF", opacity: 0.7 }} />
                </div>
                <div className="flex flex-col ml-2">
                  <p className="text-sm text-white opacity-90">Speed</p>
                  <p className="text-sm text-white opacity-90">{latestData?.speed} km/h</p>
                </div>
              </div>
            </div>
            {/* <div className="flex">
              <div className="w-[30px]">
                <NearMeOutlinedIcon sx={{ color: "#FFF", opacity: 0.7, ml: "3px" }} />
              </div>
              <div className="flex flex-col ml-2">
                <p className="text-sm text-white opacity-90">North</p>
                <p className="text-sm text-white opacity-90">17.5</p>
              </div>
            </div> */}
            <div className="flex">
              <div className="w-[30px]">
                <img
                  src="/assets/icons/orders/jobDetails/location.svg"
                  className="mx-auto"
                />
              </div>
              <div className="flex ml-2 gap-2 items-center">
                <p className="text-xs text-white opacity-90">
                  Latitude: {(latestData?.latitude).toFixed(6)}
                </p>
                <p className="text-xs text-white opacity-90">
                  Longitude: {latestData?.longitude.toFixed(6)}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrackerMarker;
